import { useMutation } from "@tanstack/react-query";
import { StudyDataType } from "@/types/apiTypes";
import { useInvalidateQueries } from "../helperHooks/useInvalidateQueries";
import { associateStudyToProjectApi } from "@/API/associateStudyToProjectApi";
import { ShowNotification } from "@/components/ShowNotification";

export const useAssociateStudyToProject = () => {
  const { invalidateStudies, invalidateStudy, invalidateProjects } =
    useInvalidateQueries();

  return useMutation({
    mutationFn: ({
      study,
      projectId,
    }: {
      study: StudyDataType;
      projectId: string;
    }) => associateStudyToProjectApi(study, projectId),

    onSuccess: (_, { study }) => {
      ShowNotification({
        title: "Success",
        message: `${study.experiment_name} has been added to the project.`,
        color: "success",
      });
      if (study.id) {
        invalidateStudy(study.id);
      }
      invalidateStudies();
      invalidateProjects();
    },

    onError: (error: Error) => {
      console.error("Error associating study:", error);
      ShowNotification({
        title: "Error",
        message: "Failed to add study to project.",
        color: "error",
      });
    },
  });
};
